export default __webpack_public_path__ + "static/media/css.a031633e.png";